import { get, isArray } from 'lodash'

export function propsWithContextMergeHelper (props, context, may_be_alias, options = {}) {

  const {
      push_props = false,
      options_alias
    } = options,
    attr_alias = typeof options === 'string'
                 ? options
                 : options_alias

  if (typeof may_be_alias === 'string') {
    return push_props
           ? {...{[may_be_alias]: context}, ...props}
           : {...{...props, [may_be_alias]: context}}
  }

  if (typeof may_be_alias === 'function') {
    return push_props
           ? {...{...may_be_alias(context, props), ...props}}
           : {...{...props, ...may_be_alias(context, props)}}
  }

  if (isArray(may_be_alias)) {
    const renamed_props = may_be_alias.reduce((result, key_string) => {
      const [left, right = left] = key_string.split(':')
      result[String(right).trim()] = get(context, String(left).trim())
      return result
    }, {})
    const context_props = attr_alias
                          ? {[attr_alias]: renamed_props}
                          : renamed_props
    return push_props
           ? {
        ...context_props,
        ...props
      }
           : {
        ...props,
        ...context_props
      }
  }

  return push_props
         ? {...context, ...props}
         : {...props, ...context}
}
